import env from 'environments';

export const PORTAL_ID = env.HS_PORTAL_ID || '3424767';

export const PLUS_PLANS_FORM_IDS = {
  digital: env.HS_DIGITAL_PLUS_FORM_ID || '348e34a7-d8dd-41ca-a8e3-704b0de0935b',
  premium: env.HS_PREMIUM_PLUS_FORM_ID || '42598c5a-41bd-4ed2-a323-5ccd0ad46946',
};
